import { SET_VALUATION_INFO } from './types';

// eslint-disable-next-line import/prefer-default-export
export const setValuationInfo = valuationInfo => ({
  type: SET_VALUATION_INFO,
  valuationInfo
});
